/* Bundle grid: search, filters, ordering and Surprise me.

   HOW IT CONNECTS
   This does not touch the DOM of the grid. It supplies SF.bundleView — a
   function the builder calls with the pool, returning the frames to show,
   filtered and sorted. The builder then renders one page of them.

   That matters. The earlier version let the builder render all 400+ frames
   and then reordered and hid them afterwards. Every pick rebuilt four
   hundred cards and then moved them again, and while the browser was busy
   the next tap did nothing — the page felt frozen and unclickable. Doing
   the work on the array instead of the DOM removes that entirely.

   ---- WHERE THE FACET DATA COMES FROM, AND WHY IT CHANGED ----
   A bundle card is a product, but every facet is a property of the FAMILY
   it belongs to. This used to fetch the whole /collections page in the
   background and read shape, material, rim and colour off the family cards
   rendered there.

   THAT QUIETLY EXCLUDED EVERY HIDDEN FAMILY. A family marked
   collection_type = hidden is sold and bundled but deliberately kept off
   the listing grid — Olympus, the Kellys, Ciao, Flirty, Maze, Biker,
   Sideways. Not being on that page meant no attributes could be scraped
   for them, so they passed while no facet was active and vanished the
   moment a shopper touched one. The frames were in the range, in stock,
   and unreachable through the filters.

   sf-data already carries all of it — shape, material, tech and types per
   family, and colour_map giving frame and lens per product — and it is
   rendered on every page including for hidden families. So the index is
   built from there instead. One less network request, nothing to parse out
   of someone else's markup, and hidden families filter like any other.

   THE COLOUR WORDS ARE FOLDED HERE rather than arriving pre-folded. The
   /collections page ran them through sf-colourlookup in Liquid before
   printing them; colour_map holds the raw words, so Rose still has to
   become Red and Gun has to become Grey before it can match a filter
   button. sf-bundlecard exposes that folding as window.SFColour, so the
   card and the filters agree by construction rather than by two lists
   being kept in step.

   NO PRICE FILTER: every frame in a tier costs the same.

   ---- THE SEARCH ----
   The range is nine hundred frames in two hundred families. A shopper who
   knows they want Casanova had no way to say so: the facets narrow by
   shape and colour, which is a different question from "where is the one I
   already have in mind", and the answer was to scroll.

   IT SEARCHES THE POOL, NOT THE STORE. This is deliberately not the site's
   predictive search. That searches everything and sends you to a product
   page, which mid-bundle means losing the selection. This one filters the
   frames already eligible for the tier on show, so anything it finds can be
   picked on the spot and anything it cannot find is genuinely not in the
   offer — which is itself worth knowing.

   WHAT IT MATCHES: the product's own title, its family's title, and the
   family handle. Every word has to match, in any order, which is what makes
   "casanova blue" narrow rather than widen.

   ---- ORDER IS BY FAMILY, NOT BY PRODUCT ----
   The pool arrives in the collection's own best-selling order, which is a
   PRODUCT order: every colourway is its own product, so the four Bavlis sit
   wherever their individual sales put them, and a shopper scrolling the
   grid met the same frame in four different places, pages apart.

   Frames are therefore grouped by family, and the families are kept in
   best-selling order of their strongest member — the position of the
   highest-placed colourway in the pool. Within a family the pool's own
   order is kept, so the best-selling colour leads.

   A product with no family in sf-data forms a group of its own and keeps
   its pool position, and passes every facet test only while no facet is
   active — the same as before, so an ungrouped frame is never silently
   dropped from an unfiltered grid.

   SURPRISE ME SHUFFLES FAMILIES, NOT FRAMES. Randomising individual
   products would put the colourways straight back where they started. */
(function(){
"use strict";
var CATS=["Sunglasses","Optical","Blue Light","Kids","Limited drops"];
var SHAPES=["Square","Round","Cat-eye","Pilot","Rectangle","Oval","Hexagon"];
var MATERIALS=["Acetate","Metal","Titanium","Polycarbonate","Carbon fibre","Acetate and metal","Wood"];
var TECHS=["Full rim","Half rim","Rimless"];
var FCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Tortoise","#8a5a2b"],["Blue","#3a5a7d"],["Green","#4c6b4f"],
["Grey","#8b8f92"],["Silver","#c9ccce"],["Gold","#b39a63"],["Red","#9c3b32"],["Pink","#e59ab4"],["Yellow","#e3c74a"],["Clear","#dfe3e4"]];
var LCOL=[["Black","#1c1c1c"],["Brown","#6b4a30"],["Green","#3f5c46"],["Blue","#3a5a7d"],["Grey","#8b8f92"],
["Yellow","#e3c74a"],["Pink","#e59ab4"],["Red","#9c3b32"],["Clear","#eef1f2"]];

var open=false;
var f={types:[],shape:[],mat:[],tech:[],fcolour:[],lcolour:[]};
var shuffle=false, shuffleOrder={};
var q='', qWords=[];

/* Translated where there is a table, English where there is not. The
   placeholder is an attribute, and sf-i18n only rewrites text nodes, so it
   cannot be left to the bridge the way a label can. */
function t(s){ return (window.SF_T && window.SF_T[s]) || s }

/* A metafield may arrive as a JSON list or as a pipe-joined string,
   depending on whether its definition is a list type. Both mean the same
   thing here. */
function asList(v){
  if(v==null) return [];
  if(Object.prototype.toString.call(v)==='[object Array]'){
    return v.map(function(x){ return String(x).trim() }).filter(Boolean);
  }
  return String(v).split('|').map(function(x){ return x.trim() }).filter(Boolean);
}

/* pid -> everything the grid needs to know about a frame that the pool
   itself does not carry: which family it is in, and that family's facets. */
var IDX=null;
function index(){
  if(IDX) return IDX;
  IDX={};
  var d={};
  try{ d=JSON.parse((document.getElementById('sf-data')||{}).textContent||'{}') }catch(e){}
  var C=window.SFColour||null;
  (d.families||[]).forEach(function(fam){
    var shape=asList(fam.shape), types=asList(fam.types), tech=asList(fam.tech);
    var mat=String(fam.material||'').trim();
    var map={};
    String(fam.cmap||'').split(';').forEach(function(e){
      var kv=e.split('='); if(kv.length<2) return;
      var parts=String(kv[1]).split('|');
      map[String(kv[0]).trim()]=[ (parts[0]||'').trim(), (parts[1]||'').trim() ];
    });
    (fam.products||[]).forEach(function(p){
      if(!p || p.pid==null || IDX[String(p.pid)]!==undefined) return;
      var e=map[String(p.pid)]||['',''];
      var fw=e[0].split('+').map(function(x){
        x=x.trim();
        return C ? C.frame(x) : x;
      }).filter(Boolean);
      var lw=C ? C.lens(e[1]) : String(e[1]).trim();
      IDX[String(p.pid)]={
        handle: fam.handle, title: fam.title||'',
        shape: shape, types: types, tech: tech, mat: mat,
        fcolour: fw, lens: lw
      };
    });
  });
  return IDX;
}
/* An unknown product is its own family rather than a shared "unknown" one,
   so a gap in sf-data cannot glue unrelated frames together. */
function famKey(p){
  var m=index()[String(p.pid)];
  return m ? 'f:'+m.handle : 'p:'+p.pid;
}
function norm(s){ return String(s||'').toLowerCase().replace(/\s+/g,' ').trim() }
function haystack(p){
  var m=index()[String(p.pid)];
  return norm(p.title+' '+(m?m.title+' '+m.handle:''));
}
function hitsQuery(p){
  if(!qWords.length) return true;
  var h=haystack(p);
  for(var i=0;i<qWords.length;i++) if(h.indexOf(qWords[i])<0) return false;
  return true;
}
function setQuery(v){
  q=String(v||'');
  qWords=norm(q).split(' ').filter(Boolean);
  var x=document.getElementById('bfQX');
  if(x) x.hidden = !q;
  redraw();
}

function count(){ return f.types.length+f.shape.length+f.mat.length+f.tech.length+f.fcolour.length+f.lcolour.length }
function passes(info){
  if(!info) return count()===0;
  if(f.types.length && !f.types.some(function(x){return info.types.indexOf(x)>-1})) return false;
  if(f.shape.length && !f.shape.some(function(s){return info.shape.indexOf(s)>-1})) return false;
  if(f.mat.length && f.mat.indexOf(info.mat)<0) return false;
  if(f.tech.length && !f.tech.some(function(x){return info.tech.indexOf(x)>-1})) return false;
  if(f.fcolour.length && !f.fcolour.some(function(c){return info.fcolour.indexOf(c)>-1})) return false;
  if(f.lcolour.length && f.lcolour.indexOf(info.lens)<0) return false;
  return true;
}
function rnd(key){
  if(shuffleOrder[key]===undefined) shuffleOrder[key]=Math.random();
  return shuffleOrder[key];
}

/* The builder calls this with the pool and renders a page of what comes
   back. The pool's own index IS the best-selling rank, so it is captured
   before filtering and used both for the family order and for the order
   inside each family. */
window.__bundleView=function(pool){
  var map=index(), pos={}, i;
  for(i=0;i<pool.length;i++) if(pos[pool[i].id]===undefined) pos[pool[i].id]=i;

  var kept=pool.filter(function(p){
    return hitsQuery(p) && passes(map[String(p.pid)]);
  });

  var groups={}, order=[];
  kept.forEach(function(p){
    var k=famKey(p), g=groups[k];
    if(!g){ g=groups[k]={key:k, rank:pos[p.id], items:[]}; order.push(g) }
    else if(pos[p.id]<g.rank) g.rank=pos[p.id];
    g.items.push(p);
  });

  order.sort(shuffle
    ? function(a,b){ return rnd(a.key)-rnd(b.key) }
    : function(a,b){ return a.rank-b.rank });

  var out=[];
  order.forEach(function(g){
    g.items.sort(function(a,b){ return pos[a.id]-pos[b.id] });
    out=out.concat(g.items);
  });
  return out;
};

/* HOW FAR DOWN THE PAGE IS ACTUALLY VISIBLE.
   Two sticky elements stack at the top here — the site header and this
   filter bar — so the first usable pixel is below both. Measured, not
   assumed: the header collapses at different widths and the bar grows when
   filters are active, so any fixed number would be wrong somewhere. */
function stickyOffset(){
  var total=0;
  ['header.hdr','#bfBar'].forEach(function(sel){
    var el=document.querySelector(sel);
    if(!el) return;
    var pos=getComputedStyle(el).position;
    if(pos!=='sticky' && pos!=='fixed') return;
    total += el.getBoundingClientRect().height||0;
  });
  return total;
}

/* scrollIntoView({block:'start'}) aligns the grid with the TOP OF THE
   VIEWPORT, which is behind those bars — that is why the first row of
   frames appeared cut in half after every shuffle. */
function scrollToGrid(){
  var g=document.getElementById('bGrid');
  if(!g) return;
  var y=g.getBoundingClientRect().top + window.scrollY - stickyOffset() - 12;
  window.scrollTo({ top: Math.max(0,y), behavior:'smooth' });
}

function paintMode(){
  var a=document.getElementById('bfBest'), b=document.getElementById('bfShuffle');
  if(a) a.setAttribute('aria-pressed', String(!shuffle));
  if(b){
    b.setAttribute('aria-pressed', String(shuffle));
    b.textContent = shuffle ? 'Shuffle again' : 'Surprise me';
  }
  var n=document.getElementById('bfN');
  if(n) n.textContent = count()? ' ('+count()+')' : '';
}
function redraw(){ if(window.SF && SF.renderBundles) SF.renderBundles(); paintMode() }

function chip(k,v){ return '<button class="chip" aria-pressed="'+(f[k].indexOf(v)>-1)+'" data-k="'+k+'" data-v="'+v+'">'+v+'</button>' }
function swatchRow(k,list){
  return list.map(function(c){
    return '<button aria-pressed="'+(f[k].indexOf(c[0])>-1)+'" data-k="'+k+'" data-v="'+c[0]+'"><i style="background:'+c[1]+'"></i>'+c[0]+'</button>';
  }).join('');
}
function panelHTML(){
  return '<div class="fgroup"><h4>Category</h4><div class="fopts">'+CATS.map(function(v){return chip('types',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><h4>Shape</h4><div class="fopts">'+SHAPES.map(function(v){return chip('shape',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><h4>Frame colour</h4><div class="cols">'+swatchRow('fcolour',FCOL)+'</div></div>'+
  '<div class="fgroup"><h4>Lens colour</h4><div class="cols">'+swatchRow('lcolour',LCOL)+'</div></div>'+
  '<div class="fgroup"><h4>Frame material</h4><div class="fopts">'+MATERIALS.map(function(v){return chip('mat',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><h4>Rim style</h4><div class="fopts">'+TECHS.map(function(v){return chip('tech',v)}).join('')+'</div></div>'+
  '<div class="fgroup"><button class="btn out sm" id="bfClear">Clear filters</button></div>';
}

function build(){
  var line=document.getElementById('bLine'), grid=document.getElementById('bGrid');
  if(!line || !grid || document.getElementById('bfBar')) return;

  var css=document.createElement('style');
  css.textContent=
    '.bfseg{display:inline-flex;border:1px solid var(--line);border-radius:999px;overflow:hidden}'+
    '.bfseg button{appearance:none;background:#fff;border:0;padding:9px 16px;font:inherit;font-size:11px;'+
      'letter-spacing:.08em;text-transform:uppercase;color:var(--mute);cursor:pointer;white-space:nowrap}'+
    '.bfseg button+button{border-left:1px solid var(--line)}'+
    '.bfseg button[aria-pressed="true"]{background:#141a19;color:#fff}'+
    '.bfseg button:hover{color:var(--ink)}'+
    '.bfseg button[aria-pressed="true"]:hover{color:#fff}';
  document.head.appendChild(css);

  var bar=document.createElement('div');
  bar.id='bfBar'; bar.className='fbar';
  bar.innerHTML='<div class="in">'+
    '<label class="bfsearch" for="bfQ">'+
      '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>'+
      '<input type="search" id="bfQ" autocomplete="off" placeholder="'+t('Search these frames')+
        '" aria-label="'+t('Search these frames')+'">'+
      '<button type="button" id="bfQX" hidden aria-label="'+t('Clear')+'">&#10005;</button>'+
    '</label>'+
    '<button class="f" id="bfToggle"><svg class="ic" viewBox="0 0 24 24"><path d="M4 6h16M7 12h10M10 18h4"/></svg>Filters<span id="bfN"></span></button>'+
    '<span class="uc" style="font-size:10.5px;color:var(--mute)" id="bfCount"></span>'+
    '<span class="bfseg" role="group" aria-label="Order">'+
      '<button id="bfBest" aria-pressed="true">Best selling</button>'+
      '<button id="bfShuffle" aria-pressed="false">Surprise me</button>'+
    '</span></div>';
  var panel=document.createElement('div');
  panel.id='bfPanel';
  panel.style.cssText='display:none;padding:6px 20px 18px;max-width:1400px;margin:0 auto';
  line.parentNode.insertBefore(bar, line);
  line.parentNode.insertBefore(panel, line);

  var moreWrap=document.createElement('div');
  moreWrap.style.cssText='text-align:center;padding:22px 20px 4px';
  moreWrap.innerHTML='<button class="btn out sm" id="bfMore" style="display:none">Show more</button>';
  grid.parentNode.insertBefore(moreWrap, grid.nextSibling);

  /* Typing repaints the whole grid, so it waits for a pause rather than
     doing it per keystroke. Escape clears, which is what a search field is
     expected to do and saves reaching for the cross. */
  var qEl=document.getElementById('bfQ'), timer=null;
  qEl.addEventListener('input', function(){
    clearTimeout(timer);
    var v=qEl.value;
    timer=setTimeout(function(){ setQuery(v) }, 160);
  });
  qEl.addEventListener('keydown', function(e){
    if(e.key==='Escape'){ qEl.value=''; clearTimeout(timer); setQuery('') }
  });
  document.getElementById('bfQX').addEventListener('click', function(){
    qEl.value=''; clearTimeout(timer); setQuery(''); qEl.focus();
  });

  document.getElementById('bfToggle').addEventListener('click', function(){
    open=!open;
    if(open && !panel.innerHTML) panel.innerHTML=panelHTML();
    panel.style.display = open ? '' : 'none';
  });
  document.getElementById('bfBest').addEventListener('click', function(){
    if(!shuffle) return;
    shuffle=false; redraw();
  });
  document.getElementById('bfShuffle').addEventListener('click', function(){
    shuffle=true; shuffleOrder={}; redraw();
    requestAnimationFrame(function(){ requestAnimationFrame(scrollToGrid) });
  });
  document.getElementById('bfMore').addEventListener('click', function(){
    if(window.SF && SF.showMoreBundles) SF.showMoreBundles();
  });
  panel.addEventListener('click', function(e){
    var b=e.target.closest ? e.target.closest('button') : null;
    if(!b) return;
    if(b.id==='bfClear'){ f={types:[],shape:[],mat:[],tech:[],fcolour:[],lcolour:[]}; panel.innerHTML=panelHTML(); redraw(); return }
    var k=b.getAttribute('data-k'), v=b.getAttribute('data-v');
    if(!k) return;
    var i=f[k].indexOf(v);
    if(i>-1) f[k].splice(i,1); else f[k].push(v);
    panel.innerHTML=panelHTML();
    redraw();
  });
  paintMode();
}

document.addEventListener('DOMContentLoaded', function(){
  if(!document.getElementById('bGrid')) return;
  if(window.SF){ SF.bundleView=window.__bundleView; SF.bundleReset=function(){}; }
  build();
});
})();